const normalizeExtension = extension =>
  String(extension ?? '')
    .replace(/^\./, '')
    .toLowerCase()

/**
 * To check if the given file extension is in the accepted extensions.
 * Accepted extensions may be given with or without a leading dot.
 */
export const checkInputErrorFileExtension = acceptedExtensions => value => {
  if (!value) return ''

  const extension = normalizeExtension(value.name?.split('.').pop())
  const normalizedAccepted = acceptedExtensions.map(normalizeExtension)

  return normalizedAccepted.includes(extension)
    ? ''
    : `Formato no permitido. Solo se aceptan: ${acceptedExtensions.join(', ')}.`
}
